export default "__VITE_ASSET__6f7d9ca8__"